import React, { Component } from 'react'
import classnames from "classnames";
import Button from '../shared/Button/index';

import baseStyles from 'custom/base.styl';
import { profileUpdateStages, profileFetch } from "../../store/profile/actions";
import { connect } from "react-redux";

import {
  textWelcome,
  textWelcomeMath,
  textWelcomeFinance,
  welcomeTitle,
} from 'custom/textWelcome';

class LanguageTestWelcome extends Component {
  constructor(props) {
    super(props)

    this._handleSubmit = this._handleSubmit.bind(this)
  }

  _handleSubmit(e) {
    e.preventDefault()

    this.props.profileUpdateStages()
  }

  render() {
    const { version, profile } = this.props;
    const subjectType = profile && profile.subject_type;

    if (!version) {
      return null;
    }
    const minutes = version === 'v0' ? 25 : 15;
    let count = version === 'v0' ? 45 : 24;
    let description = textWelcome;

    switch (subjectType) {
      case 'math':
        description = textWelcomeMath;
        break;
      case 'finance':
        description = textWelcomeFinance;
        break;
      default:
        break;
    }

    return (
      <div>
        <div className={baseStyles.header}><h1 className={baseStyles.title}>{welcomeTitle}</h1></div>
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)}>
          <form onSubmit={this._handleSubmit} method="post">
            <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_30)}>
              {description}
            </p>
            <p className={classnames(baseStyles.succeess_title)}>The language test will take only {minutes} minutes of your time:</p>

            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
              <li>There are <b>{count}</b> multiple choice questions.</li>
              <li><b>Only one</b> answer is correct.</li>
              <li>You will <b>not be able to either pause or restart</b> the test.</li>
              <li>You will need to <b>answer all the questions</b> before the time runs out.</li>
            </ul>

            <Button type="submit">Start a test</Button>
          </form>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    error: state.profile.error,
    version: state.profile && state.profile.data && state.profile.data.user && state.profile.data.user.scenario_version,
    profile: state.profile && state.profile.data && state.profile.data.user && state.profile.data.user.profile,
  }),
  (dispatch) => ({
    profileUpdateStages: () => (dispatch(profileUpdateStages())),
    loadProfile: () => dispatch(profileFetch()),
  })

)(LanguageTestWelcome)




// WEBPACK FOOTER //
// ./src/components/LanguageTest/PageLanguageTestWelcome.js